module.exports = __webpack_public_path__ + "img/AI_PLAZA.d952d721.png";